import { Info } from 'lucide-react'

interface InstructionButtonProps {
  onClick: () => void
}

export function InstructionButton({ onClick }: InstructionButtonProps) {
  return (
    <button
      className="flex items-center gap-2 rounded-full border border-[#2bcaca] px-4 py-1.5 text-[#2bcaca] transition-colors hover:bg-[#2bcaca]/10"
      onClick={onClick}
    >
      <Info className="h-4 w-4" />
      <span className="font-medium">Instrukcje</span>
    </button>
  )
}
